export const { history, location } = globalThis;
